module.exports = __webpack_public_path__ + "img/linkedin.5d179680.svg";